/**
 * <load-more-products>: the seasonal grid's "Load more" (feature 017, specs/017-seasonal-collection-theme/research.md R8).
 * The button is a link to the next page, so without JavaScript it pages normally. Here it fetches that
 * page through the Section Rendering API, appends its products to #product-grid, copies the new status,
 * bar and next link, and moves focus to the first new product. Repeat clicks during a load are ignored;
 * if the fetch fails the link is followed. The address is not changed (filters and sort are, by facets.js).
 */
if (!customElements.get('load-more-products')) {
  class LoadMoreProducts extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.load-more__button');
      this.button?.addEventListener('click', (event) => this.onClick(event));
    }

    async onClick(event) {
      event.preventDefault();
      if (this.loading) return;
      const href = this.button.getAttribute('href');
      const grid = document.getElementById('product-grid');
      if (!grid) {
        window.location.href = href;
        return;
      }

      this.loading = true;
      grid.setAttribute('aria-busy', 'true');
      this.button.setAttribute('aria-disabled', 'true');
      try {
        const url = new URL(href, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const items = [...html.querySelectorAll('#product-grid > li')];
        if (!items.length) throw new Error('No products in the next page');

        grid.append(...items);
        this.update(html.querySelector('load-more-products'));
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(grid);
        // The card's own link (the photo link is aria-hidden and out of the tab order)
        const firstLink =
          items[0].querySelector('.gift-card__title') || items[0].querySelector('a[href]:not([tabindex="-1"])');
        firstLink?.focus();
      } catch (error) {
        window.location.href = href;
      } finally {
        this.loading = false;
        grid.removeAttribute('aria-busy');
        this.button?.removeAttribute('aria-disabled');
      }
    }

    update(next) {
      const status = this.querySelector('.load-more__status');
      const fill = this.querySelector('.load-more__bar-fill');
      const nextStatus = next?.querySelector('.load-more__status');
      const nextFill = next?.querySelector('.load-more__bar-fill');
      const nextButton = next?.querySelector('.load-more__button');
      if (status && nextStatus) status.textContent = nextStatus.textContent;
      if (fill && nextFill) fill.style.width = nextFill.style.width;
      if (nextButton) {
        this.button.setAttribute('href', nextButton.getAttribute('href'));
      } else {
        this.button.remove();
        this.button = null;
      }
    }
  }

  customElements.define('load-more-products', LoadMoreProducts);
}
